import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import Button, {LinkButton} from '../../../components/button/button';
import ArrowBlockDownIcon from '../../../assets/icons0/arrow-block-down.svg';
import './ticketing-download-pop-up.scss';


const TicketingDownloadPopUp = ({filesToDownload, showDownloadPopUp, setShowDownloadPopUp}) => {
    return (
         <div className={classNames('ticketing-download-pop-up', {'ticketing-download-pop-up--visible': showDownloadPopUp})}>
            <div className='ticketing-download-pop-up__container'>
                <div className='ticketing-download-pop-up__title medium text-sm mw768-text-lg'>
                    <FormattedMessage defaultMessage='Download tickets'/>
                </div>
                <div className='ticketing-download-pop-up__content display-flex flex-direction-column row-gap-0dot75rem'>
                    {filesToDownload.map((file, index) => (
                        <LinkButton key={index} {...{color: 'primary-inverse', size: 'lg', fluid: 'always', link: {href: file.url, target: '_blank'}}} >
                            <ArrowBlockDownIcon className='display-block width-1dot25rem height-1dot25rem margin-right-0dot5rem'/>
                            <FormattedMessage defaultMessage='Download ticket'/>
                        </LinkButton>
                    ))}
                    <Button {...{color: 'secondary-gray', size: 'lg', fluid: 'always', clickHandler: () => setShowDownloadPopUp(false)}}>
                        <FormattedMessage defaultMessage='Cancel'/>
                    </Button>
                </div>
            </div>
        </div>
    )
};

export default React.memo(TicketingDownloadPopUp);
